(function () {
  'use strict';

  const KEYS = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(slider) {
    if (slider.dataset.customSliderInitialized) return;
    slider.dataset.customSliderInitialized = 'true';

    const ss = slider.querySelector('slideshow-component');
    if (!ss) return;

    const slidesContainer = slider.querySelector('slideshow-slides');
    const status = slider.querySelector('[data-custom-slider-status]');
    const scrollbar = slider.querySelector('.custom-slider__scrollbar');
    const thumb = scrollbar ? scrollbar.querySelector('[data-custom-slider-scrollbar-thumb]') : null;

    if (reduceMotion.matches) {
      ss.removeAttribute('autoplay');
    }

    function totalSlides() {
      if (!slidesContainer) return 0;
      return parseInt(slider.dataset.slideCount, 10) || 0;
    }

    function currentPerView() {
      const w = window.innerWidth;
      const desktop = parseFloat(slider.dataset.perViewDesktop || '1') || 1;
      const tablet = parseFloat(slider.dataset.perViewTablet || slider.dataset.perViewDesktop || '1') || desktop;
      const mobile = parseFloat(slider.dataset.perViewMobile || '1') || 1;
      if (w >= 1024) return desktop;
      if (w >= 750) return tablet;
      return mobile;
    }

    function updateArrowsVisibility() {
      const total = totalSlides();
      const perView = currentPerView();
      // Hide arrows when all slides fit (Math.ceil handles fractional peeks like 1.5).
      if (total <= Math.ceil(perView)) {
        slider.setAttribute('data-arrows-hidden', '');
      } else {
        slider.removeAttribute('data-arrows-hidden');
      }
    }

    updateArrowsVisibility();
    window.addEventListener('resize', updateArrowsVisibility, { passive: true });

    function announce(index) {
      if (!status) return;
      const total = totalSlides();
      if (total <= 1) return;
      status.textContent = 'Slide ' + (index + 1) + ' of ' + total;
    }

    ss.addEventListener('slideshow:select', (e) => {
      const idx = (e && e.detail && typeof e.detail.index === 'number') ? e.detail.index : 0;
      announce(idx);
    });

    slider.addEventListener('keydown', (e) => {
      if (!KEYS.includes(e.key)) return;
      const t = e.target;
      if (t && t.matches && t.matches('input, textarea, select, [contenteditable], button, a')) return;
      e.preventDefault();
      if (e.key === 'ArrowRight') ss.next();
      else if (e.key === 'ArrowLeft') ss.previous();
      else if (e.key === 'Home') ss.select(0);
      else if (e.key === 'End') ss.select(totalSlides() - 1);
    });

    if (scrollbar && thumb && slidesContainer) {
      let rafId = null;
      const update = () => {
        if (rafId !== null) return;
        rafId = requestAnimationFrame(() => {
          rafId = null;
          const sw = slidesContainer.scrollWidth;
          const cw = slidesContainer.clientWidth;
          const sl = slidesContainer.scrollLeft;
          if (sw <= cw + 1) {
            scrollbar.style.display = 'none';
            return;
          }
          scrollbar.style.display = '';
          const trackW = scrollbar.clientWidth;
          if (trackW <= 0) return;
          const ratio = cw / sw;
          const thumbW = Math.max(48, ratio * trackW);
          const maxX = trackW - thumbW;
          const x = (sl / (sw - cw)) * maxX;
          thumb.style.width = thumbW + 'px';
          thumb.style.transform = 'translateX(' + x + 'px)';
        });
      };
      slidesContainer.addEventListener('scroll', update, { passive: true });
      if (typeof ResizeObserver === 'function') {
        new ResizeObserver(update).observe(slidesContainer);
        new ResizeObserver(update).observe(scrollbar);
      } else {
        window.addEventListener('resize', update);
      }
      update();
    }

    announce(typeof ss.current === 'number' ? ss.current : 0);
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-custom-slider]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
